import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Manipulation } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Thumbs, Manipulation]);

let sliderInstance = null;

const initSliders = () => {
  const container = document.querySelector('.gallery-navigation--thumbnails');

  if (!container) return;

  if (sliderInstance && sliderInstance.destroy) {
    sliderInstance.destroy(true, true);
  }


  sliderInstance = new Swiper(container, {
    slidesPerView: "auto",
    spaceBetween: 20,
    navigation: {
      nextEl: '.scroll-right',
      prevEl: '.scroll-left',
    },
    // breakpoints: {
    //   900: { slidesPerView: 2 },
    //   1350: { slidesPerView: 3 },
    //   1400: { slidesPerView: 3 },
    // },
  });
};



const initUpsellSlider = () => {
  //Upsell Sliders
  const upsellContainer = document.querySelector('.upsell-slider-wrapper');
  if (!upsellContainer) return;

  const upsellSwiper = new Swiper(upsellContainer, {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '.recommendations-wrapper .swiper-button-next',
      prevEl: '.recommendations-wrapper .swiper-button-next',
    }
  });

  const setupHandlers = () => {
    const prevButton = document.querySelector('#side-cart-upsells .swiper-button-prev');
    const nextButton = document.querySelector('#side-cart-upsells .swiper-button-next');

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', (e) => {
        upsellSwiper.slidePrev();
      });

      nextButton.addEventListener('click', (e) => {
        upsellSwiper.slideNext();
      });
    }
  }

  setupHandlers();

  document.addEventListener("upsell:added", (e) => {
    const activeIndex = upsellSwiper.activeIndex;
    upsellSwiper.removeSlide(activeIndex); // remove the active slide
    upsellSwiper.update(); // update swiper layout
    setupHandlers();

    // Check if no slides remain
    if (upsellSwiper.slides.length === 0) {
        document.querySelector('#side-cart-upsells').classList.add('hide');
    }
  });
}

export { initSliders, initUpsellSlider };
